<template>
    <sidebar @close="$emit('close')">
        <template v-slot:title>
            {{ locationName }} Taxes
        </template>

        <template v-slot:header>
            <div class="row mb-2">
                <div class="col-8">
                    <span class="text-semibold">Company: </span>
                    <span>{{ company.name }}</span>
                </div>
                <div class="col-4 text-right">
                    <button type="button" class="btn btn-outline-primary" @click.prevent="editModalOpen = true">
                        <i class="far fa-pen" aria-hidden="true" title="Edit"></i>
                        Edit
                    </button>
                </div>
            </div>

        </template>

        <slot>
            <info-widget v-for="taxRegistration in sortedCompanyTaxRegistrations" :collapsible="false" :key="taxRegistration.id">
                <template v-slot:title>
                    {{ taxRegistration.sym_tax.description }}
                </template>

                <slot>
                    <div class="card-body py-1 mt-1">
                        <div class="mui-textfield">
                            <span class="textfield" v-if="taxRegistration.filing_id">{{ taxRegistration.filing_id }}</span>
                            <span class="textfield" v-else><em>None</em></span>
                            <label>Filing Id</label>
                        </div>

                        <div class="mui-textfield">
                            <span class="textfield">{{ taxRegistration.status_pretty }}</span>
                            <label>Registration Status</label>
                        </div>

                        <div class="mui-textfield">
                            <span class="textfield">{{ taxRegistration.is_exempt ? 'Exempt' : 'No' }} <i v-show="taxRegistration.is_exempt" class="far fa-fw fa-skull-crossbones text-danger"></i></span>
                            <label>Exempt Status</label>
                        </div>

                        <div class="mui-textfield">
                            <span class="textfield">{{ taxRegistration.is_voluntary ? 'Yes' : 'No' }}</span>
                            <label>Voluntary tax registration?</label>
                        </div>

                        <div class="mui-textfield" v-if="taxRegistration.sym_tax.needs_rate">
                            <span class="textfield" v-if="taxRegistration.rate !== null">{{ formatRate(taxRegistration.rate) }}</span>
                            <span class="textfield" v-else><em>None</em></span>
                            <label>Rate</label>
                        </div>

                        <div class="mui-textfield" v-if="currentParameterSet(taxRegistration)">
                            <span class="textfield">{{ formatEffectiveDate(currentParameterSet(taxRegistration).effective_on) }}</span>
                            <label>Rate Effective Date</label>
                        </div>

                        <div class="mui-textfield" v-if="(taxRegistration.parameter_sets || []).length > 1">
                            <span class="textfield">
                                <span v-for="parameterSet in sortedParameterSets(taxRegistration)" :key="parameterSet.id" class="d-block">
                                    {{ formatEffectiveDate(parameterSet.effective_on) }}<span v-if="parameterSet.rate !== null">: {{ formatRate(parameterSet.rate) }}</span>
                                </span>
                            </span>
                            <label>Rate History</label>
                        </div>


                    </div>
                </slot>
            </info-widget>
        </slot>

        <form-modal
            v-if="editModalOpen"
            :companyTaxRegistrations="companyTaxRegistrations"
            :client="client"
            :company="company"
            :locationName="locationName"
            :stateCode="stateCode"
            @updated="onUpdate"
            @close="editModalOpen = false"
        />
    </sidebar>
</template>

<script>
import Sidebar from '@/components/Sidebar'
import InfoWidget from '@/components/InfoWidget'
import ButtonRow from '@/components/ButtonRow'
import FormModal from './FormModal'

export default {
    props: ['locationName', 'companyId', 'companyTaxRegistrations', 'client', 'tab', 'stateCode', ],
    components: {Sidebar, InfoWidget, ButtonRow, FormModal},
    computed: {
        company() {
            return this.client.companies.find(c => c.id == this.companyId)
        },
        sortedCompanyTaxRegistrations() {
            const result = Array.from(this.companyTaxRegistrations)
            result.sort((a, b) => a.sym_tax.sort_priority > b.sym_tax.sort_priority ? 1 : -1)
            return result
        },
    },
    data() {
        return {
            taxRegistration: null,
            activeTab: this.tab || 'main',
            editModalOpen: false,
        }
    },
    methods: {
        onUpdate(obj) {
            this.$emit('updated')
        },
        sortedParameterSets(taxRegistration) {
            const parameterSets = (taxRegistration.parameter_sets || []).slice()
            parameterSets.sort((a, b) => {
                if (!a.effective_on) {
                    return -1
                }
                if (!b.effective_on) {
                    return 1
                }
                return a.effective_on < b.effective_on ? -1 : 1
            })
            return parameterSets
        },
        currentParameterSet(taxRegistration) {
            const today = new Date().toISOString().slice(0, 10)
            const applicable = this.sortedParameterSets(taxRegistration).filter(parameterSet => {
                return !parameterSet.effective_on || parameterSet.effective_on <= today
            })
            return applicable.length ? applicable[applicable.length - 1] : null
        },
        formatEffectiveDate(effectiveOn) {
            if (!effectiveOn) {
                return 'Initial'
            }
            return this.$filters.date(effectiveOn, 'MM/DD/Y')
        },
        formatRate(rate) {
            const value = Number(rate)
            if (isNaN(value)) {
                return `${rate}%`
            }
            // At least 2 decimal places; keep more only when the rate
            // genuinely has sub-0.01% precision (e.g. 0.1175%).
            const twoPlaces = value.toFixed(2)
            if (Number(twoPlaces) == value) {
                return `${twoPlaces}%`
            }
            return `${value.toFixed(4).replace(/0+$/, '')}%`
        },
    },
}
</script>
